import React from 'react';
import PropTypes from 'prop-types';

import SourceAndDestination from "../SourceAndDestination";
import SwipeableTrackingCard from "../SwipeableTrackingCard";
import Driver from "../Driver";
import TrackingMap from "../TrackingMap";
import BookingDetails from "../BookingDetails";
import SendCodOtp from '../SendCodOtp';
import SendOtpSecure from '../SendOtpSecure';
import { Helmet } from "react-helmet";
import mapFocusImage from "./change-icon.svg";
import isRequiredIf from "../../utils/propValidators";

import './style.css';

export default class TrackingContainer extends React.Component {
  // routePolyline, destination is optional for certain serviceTypes, e.g. go-car-rental
  static propTypes = {
    baseMaps: PropTypes.string.isRequired,
    customerName: PropTypes.string.isRequired,
    serviceType: PropTypes.string.isRequired,
    countryCode: PropTypes.string,
    customerType: PropTypes.string,
    subStatus: PropTypes.string,
    packageDescription: PropTypes.string,
    storeOrderId: PropTypes.string,
    status: PropTypes.string.isRequired,
    isReblast: PropTypes.bool,
    cancelReasonDescription: PropTypes.string,
    receiverName: PropTypes.string,
    routePolyline: isRequiredIf((props) => props.serviceType !== 'go-car-rental', PropTypes.string),
    driver: PropTypes.shape({
      name: PropTypes.string,
      vehicleModel: PropTypes.string,
      registrationNumber: PropTypes.string,
      photographUrl: PropTypes.string,
      location: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
      }),
    }),
    images: PropTypes.shape({
      serviceTypeLogo: PropTypes.string,
      driverMarkerIcon: PropTypes.string,
    }),
    source: PropTypes.shape({
      name: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
      latitude: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired,
    }).isRequired,
    destination: isRequiredIf((props) => props.serviceType !== 'go-car-rental', PropTypes.shape({
      name: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
      latitude: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired,
    })),
    pickupEta: PropTypes.number,
    dropoffEta: PropTypes.number,
    route: PropTypes.shape({
      dynamic: PropTypes.shape({
        visibility: PropTypes.bool,
        polylines: PropTypes.arrayOf(PropTypes.string),
      }),
      static: PropTypes.shape({
        visibility: PropTypes.bool,
        polylines: PropTypes.arrayOf(PropTypes.string),
      }),
    }),
    snappedSegment: PropTypes.arrayOf(PropTypes.shape({
      latitude: PropTypes.number,
      longitude: PropTypes.number,
    })),
    trackingEvents: PropTypes.shape({
      create: PropTypes.string,
      allocate: PropTypes.string,
      outForPickup: PropTypes.string,
      pickup: PropTypes.string,
      outForDelivery: PropTypes.string,
      delivery: PropTypes.string,
    }),
    documents: PropTypes.shape({
      pop: PropTypes.string,
      pod: PropTypes.string,
    }),
    bookingType: PropTypes.string,
    maskedSenderPhoneNumber: PropTypes.string,
    paymentDetails: PropTypes.shape({
      cashOnDeliveryAmount: PropTypes.number,
      amountPaidByCredits: PropTypes.number,
      amountPaidByCash: PropTypes.number,
      amountPaidByGopayCoins: PropTypes.number,
      amountPaidByCard: PropTypes.number,
      amountToBePaidByRecipient: PropTypes.number,
    }),
    otpSecure: PropTypes.string
  };

  state = {
    autoMapFocus: true,
    isDesktopView: false,
    isPortraitOrientation: true,
    isCardOpen: false,
  };

  maxMobileScreenWidth = 768;

  componentDidMount() {
    this.setState({
      isDesktopView: window.innerWidth >= this.maxMobileScreenWidth,
    })

    window.addEventListener('resize', this.handleResize);
    this.handleContainerResize()
  }

  handleResize = () => {
    this.setState({
      isDesktopView: window.innerWidth >= this.maxMobileScreenWidth,
      isPortraitOrientation: this.isDeviceInPortraitMode(),
    }, () => {
      this.handleContainerResize();
    })
  }

  isDeviceInPortraitMode = () => {
    return typeof (window.orientation) === "undefined" ? true : window.orientation === 0;
  }


  handleContainerResize = () => {
    this.forceUpdate();
  }

  handleCardToggle = (isOpen) => {
    this.setState({ isCardOpen: isOpen });
  };

  setAutoFocus = () => {
    this.setState({
      autoMapFocus: true
    });
  }

  onBoundsChange(evt) {
    if (!evt) {
      this.setState({
        autoMapFocus: false
      });
    }
  }

  trackingContainerCardRef = React.createRef();
  bookingDetailsRef = React.createRef();

  isGoSendPartnerOrderOnHold = () => {
    const { status, subStatus = '', serviceType, customerType } = this.props

    if (customerType === "partner") {
      if (serviceType === "go-kilat-new" && subStatus === "on-hold") {
        return true
      }
      if (serviceType === "sameday-kilat" ? (status === "driver-found" && subStatus === "allocated") || (status === "picked-up" && (subStatus === "picked" || subStatus === "on-hold")) : false) {
        return true
      }
      if (serviceType === "instant-mpmd" ? (status === "driver-found" && subStatus === "allocated") || (status === "picked-up" && (subStatus === "picked" || subStatus === "on-hold")) : false) {
        return true
      }
      if (serviceType === "go-send-instant-2w" ? (status === "driver-found" && subStatus === "allocated") || (status === "picked-up" && (subStatus === "picked" || subStatus === "on-hold")) : false) {
        return true
      }
    }

    return false
  }

  driverLatLng = () => {
    if (this.props.driver && this.props.driver.location && !this.isGoSendPartnerOrderOnHold()) {
      return (
        {
          title: "Driver Location",
          latitude: this.props.driver.location.lat,
          longitude: this.props.driver.location.lng,
        });
    }
    return null;
  };

  getMarkers = () => {
    const driver = this.driverLatLng()
    return {
      source: {
        title: "Source",
        latitude: this.props.source.latitude,
        longitude: this.props.source.longitude,
      },
      dest: {
        title: "Destination",
        latitude: this.props.destination?.latitude,
        longitude: this.props.destination?.longitude,
      },
      driver: driver,
    };
  };

  driverDetails = () => {
    return (
      <>
        {this.props.driver ? (
          <Driver
            serviceType={this.props.serviceType}
            name={this.props.driver.name}
            vehicleNumber={this.props.driver.registrationNumber}
            vehicleModel={this.props.driver.vehicleModel}
            photographUrl={this.props.driver.photographUrl}
          />
        ) : this.isGoSendPartnerOrder() ? (
          this.props.isReblast ? (
            <Driver serviceType={this.props.serviceType} />
          ) : null
        ) : (
          <Driver serviceType={this.props.serviceType} />
        )}
      </>
    );
  };

  bottomCardHeight = () => {
    if (this.trackingContainerCardRef.current) {
      return this.trackingContainerCardRef.current.clientHeight;
    }
    return this.isGoSendPartnerOrder() ? 276 : 161;
  }

  autoSnapButton() {
    if (!this.state.autoMapFocus) {
      const setAutoFocus = () => this.setAutoFocus();

      return (
        <div style={{ bottom: this.bottomCardHeight() + 16 }} className="MapFocusButton" onClick={setAutoFocus}>
          <img src={mapFocusImage} alt="map focus button" />
        </div>
      );
    } else {
      return null;
    }
  }

  isGoSendPartnerOrder() {
    const { customerType, serviceType } = this.props;
    return (customerType === "partner") && (serviceType === "go-kilat-new" || serviceType === "sameday-kilat" || serviceType === "instant-mpmd" || serviceType === "go-send-instant-2w");
  }

  isGoSendCODOrder = () => {
    const codAmount = this.props.paymentDetails?.cashOnDeliveryAmount ?? 0;
    return codAmount > 0;
  }

  sourceAndDestination(isCardOpen, isGoSendPartnerOrder) {
    return (
      <SourceAndDestination
        serviceType={this.props.serviceType}
        sourceName={this.props.source.name}
        sourceAddress={this.props.source.address}
        destinationName={this.props.destination?.name}
        destinationAddress={this.props.destination?.address}
        isGoSendPartnerOrder={isGoSendPartnerOrder}
        isCardOpen={isCardOpen}
        isDesktopView={this.state.isDesktopView}
      />
    )
  }

  basicCardDetails = (isCardOpen = false, isGoSendPartnerOrder = false) => {
    return (
      <>
        {this.driverDetails()}
        {this.sourceAndDestination(isCardOpen, isGoSendPartnerOrder)}
      </>
    )
  }

  trackingCardDetails = () => {
    if (this.isGoSendPartnerOrder() || this.isGoSendCODOrder()) {
      return (
        <SwipeableTrackingCard
          packageDescription={this.props.packageDescription}
          storeOrderId={this.props.storeOrderId} customerName={this.props.customerName}
          bottomCardHeight={this.bottomCardHeight}
          cardRef={this.trackingContainerCardRef}
          handleContainerResize={this.handleContainerResize}
          trackingEvents={this.props.trackingEvents}
          documents={this.props.documents}
          serviceType={this.props.serviceType}
          status={this.props.status}
          subStatus={this.props.subStatus}
          isReblast={this.props.isReblast}
          cancelReasonDescription={this.props.cancelReasonDescription}
          receiverName={this.props.receiverName}
          renderFixedDetails={(isCardOpen) => this.basicCardDetails(isCardOpen, true)}
          isPortraitOrientation={this.state.isPortraitOrientation}
          isDesktopView={this.state.isDesktopView}
          paymentDetails={this.props.paymentDetails}
          onCardToggle={this.handleCardToggle} />
      )
    }

    return (<div className="TrackingContainer-card" ref={this.trackingContainerCardRef}>
      {this.basicCardDetails()}
    </div>
    )
  }

  getRoute = () => {
    if (this.isGoSendPartnerOrderOnHold()) {
      return null
    }

    return this.props.route
  }

  getContainerStyle = () => {
    if (!this.state.isDesktopView && this.isGoSendPartnerOrder()) {
      return { height: window.innerHeight }
    }

    return {}
  }

  getPageTitle = () => {
    if (this.isGoSendPartnerOrder()) {
      return `GoSend Live Tracking`
    }

    return `${this.props.customerName}'s trip`
  }

  getImage = (image) => {
    const { images } = this.props
    return images && images[image] ? images[image] : ""
  }

  isActiveOTWBooking = () => {
    const { status = "" } = this.props;

    const isPickup = status === "driver-found";
    const isDropOff = status === "picked-up";

    return isPickup || isDropOff;
  };

  render() {
    const isStatusPickedUp = status => (status === "picked-up")
    const isStatusOnHold = status => (status === "on-hold")
    const isGoSendReturnBooking = (status, subStatus) => (isStatusPickedUp(status) && isStatusOnHold(subStatus))
    const markers = this.getMarkers();
    const autoSnapButton = this.autoSnapButton();
    const onBoundsChange = (evt) => this.onBoundsChange(evt);
    const topCardHeight = this.bookingDetailsRef.current ? this.bookingDetailsRef.current.cardHeightWithPadding() + 40 : 100;
    const isBookingCompleted = (this.props.status === "completed");
    const paymentDetails = this.props.paymentDetails || {};
    const cashOnDeliveryAmount = paymentDetails.cashOnDeliveryAmount ?? 0;
    const shouldShowOtpPill = cashOnDeliveryAmount > 0 && isGoSendReturnBooking(this.props.status, this.props.subStatus);
    const maskedSenderPhoneNumber = this.props.maskedSenderPhoneNumber ?? "";
    const isCODBooking = (cashOnDeliveryAmount > 0);
    const otpSecure = this.props.otpSecure ?? "";
    const isOTWBooking = this.isActiveOTWBooking() && !isGoSendReturnBooking(this.props.status, this.props.subStatus);
    const shouldShowOtpSecure = (otpSecure !== "" && maskedSenderPhoneNumber !== "") && isOTWBooking;
    const OVERLAP_PX = 10;

    let otpPill = null;
    if (shouldShowOtpPill && maskedSenderPhoneNumber) {
      const otpClassName = `CodOtpWrapper ${this.state.isCardOpen ? 'CodOtpWrapper--hidden' : ''}`;
      if (this.state.isDesktopView) {
        otpPill = (<SendCodOtp maskedPhoneNumber={maskedSenderPhoneNumber} isDesktopView />);
      } else {
        otpPill = (<div className={otpClassName} style={{ bottom: this.bottomCardHeight() }}>
          <SendCodOtp maskedPhoneNumber={maskedSenderPhoneNumber} />
        </div>);
      }
    }

    return (
      <div className={`TrackingContainer ${this.isGoSendPartnerOrder() ? 'Swipeable' : ''}`} style={this.getContainerStyle()}>
        <Helmet>
          <title>{this.getPageTitle()}</title>
        </Helmet>

        <TrackingMap
          token={this.props.token}
          onBoundsChange={onBoundsChange}
          autoMapFocus={this.state.autoMapFocus}
          serviceType={this.props.serviceType}
          countryCode={this.props.countryCode}
          topCardHeight={topCardHeight}
          bottomCardHeight={this.bottomCardHeight()}
          source={markers.source}
          destination={markers.dest}
          driver={markers.driver}
          routePolyline={this.props.routePolyline}
          bookingComplete={isBookingCompleted}
          route={this.getRoute()}
          baseMaps={this.props.baseMaps}
          snappedSegment={this.props.snappedSegment}
          status={this.props.status}
          isGoSendPartnerOrder={this.isGoSendPartnerOrder()}
          isGoSendPartnerOrderOnHold={this.isGoSendPartnerOrderOnHold()}
          isDesktopView={this.state.isDesktopView}
          bookingType={this.props.bookingType}
          driverMarkerIcon={this.getImage("driverMarkerIcon")}
        />
        {autoSnapButton}
        <div className={"DetailsContainer"}>
          <BookingDetails
            ref={this.bookingDetailsRef}
            customerName={this.props.customerName}
            serviceType={this.props.serviceType}
            countryCode={this.props.countryCode}
            status={this.props.status}
            subStatus={this.props.subStatus || ''}
            pickupEta={this.props.pickupEta}
            dropoffEta={this.props.dropoffEta}
            isGoSendPartnerOrderOnHold={this.isGoSendPartnerOrderOnHold()}
            isGoSendPartnerOrder={this.isGoSendPartnerOrder()}
            isReblast={this.props.isReblast}
            serviceTypeLogo={this.getImage("serviceTypeLogo")}
            customerType={this.props.customerType}
            isCODBooking={isCODBooking}
          />
          {otpPill}
          {shouldShowOtpSecure && (
            this.state.isDesktopView ?
              (<div className="DetailsContainer__otpSecureDesktop">
                <SendOtpSecure
                  maskedPhoneNumber={this.props.maskedSenderPhoneNumber}
                  code={this.props.otpSecure}
                  status={this.props.status}
                  isDesktopView /> </div>) :
              (<div className="DetailsContainer__otpSecureMobile">
                <SendOtpSecure
                  maskedPhoneNumber={this.props.maskedSenderPhoneNumber}
                  code={this.props.otpSecure}
                  status={this.props.status}
                  bottomOffset={this.bottomCardHeight() - OVERLAP_PX}
                /></div>))
          }
          <div className={`CardWrapper ${shouldShowOtpSecure ? 'CardWrapper--withOtp' : ''}`}>
            {this.trackingCardDetails()}
          </div>
        </div>
      </div>
    );
  }
}
